var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmall1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36319 0.5H0.358887V8.39429L6.36319 12.5L12.3589 8.39429V0.5H6.36319Z",
    fill: "#F86D9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.358887 0.5L12.3589 8.39429V0.5H0.358887Z",
    fill: "#FBA0BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.358887 8.39429L6.35459 12.5L12.3589 8.39429V0.5L0.358887 8.39429Z",
    fill: "#F1367A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmall1);
export default __webpack_public_path__ + "static/media/small1.fca41a7f6cdedf6666d2f99866526b47.svg";
export { ForwardRef as ReactComponent };